import { Switch as HSwitch } from '@headlessui/react';
import clsx from 'clsx';

interface SwitchProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  size?: 'sm' | 'md';
  disabled?: boolean;
}

const Switch = ({ checked, onChange, size = 'md', disabled }: SwitchProps) => {
  const track = size === 'sm' ? 'h-5 w-9' : 'h-6 w-11';
  const knob = size === 'sm' ? 'h-3.5 w-3.5' : 'h-4 w-4';
  const shift = size === 'sm' ? 'translate-x-4' : 'translate-x-5';

  return (
    <HSwitch
      checked={checked}
      onChange={onChange}
      disabled={disabled}
      className={clsx(
        'relative inline-flex shrink-0 cursor-pointer items-center rounded-full transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-500/50 disabled:cursor-not-allowed disabled:opacity-60',
        track,
        checked ? 'bg-brand-500' : 'bg-gray-300 dark:bg-gray-700'
      )}
    >
      <span
        className={clsx(
          'inline-block transform rounded-full bg-white transition-transform',
          knob,
          checked ? shift : 'translate-x-1'
        )}
      />
    </HSwitch>
  );
};

export default Switch;
